import React from 'react';
import './SessionLoader.css';

const SessionLoader: React.FC = () => {
  return (
    <div className="session-loader-container">
      <div className="session-loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default SessionLoader;

